export const INTERNAL_USER_ROLES: UserRoles[] = [
  'ROLE_INTERNAL_USER',
  'ROLE_ADMIN',
  'ROLE_DEVELOPER',
];
